//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StatusBar from '../components/StatusBar.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import PopupPickerSelector from '../components/PopupPickerSelector.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import utils from '../utils/index'
import * as CONSTANTS from '../constants/index'
import SnkUpload from '../libs/snkUpload.min.js'
import SearchInput from '../components/SearchInput.vue'
import { Popup, Overlay } from 'vant'
import ImgRecord from '../components/ImgRecord.vue'
import AlertToShop from './../components/AlertToShop.vue'

export default {
  name: 'BaseMsg',
  data() {
    return {
      address: '',
      isLoaded: false,
      startDateExp: utils.beautyFormatDate(new Date(), 'yyyy-mm-dd'),
      endDateExp: '2056-01-01',
      endDate: utils.beautyFormatDate(new Date(), 'yyyy-mm-dd'),
      certificateNo: '新车购置发票号',
      certificateDate: '购车发票开具日期',
      transferCar: false,
      policyStyles: null,
      value: '',
      applicantMsg: '',
      insuredMsg: '',
      carBeans: utils.deepClone(CONSTANTS.CAR_BEANS),
      salesInvoice: [
        Object.keys(CONSTANTS.BASE_BEAN.CERTIFICATE_TYPES).map((key) => {
          return {
            name: CONSTANTS.BASE_BEAN.CERTIFICATE_TYPES[key],
            value: `${key}`,
          }
        }),
      ],
      isLoading: true,
      isBeiJing: false,
      showDialog: false,
      imgUrl: [
        { src: require('../assets/pic_xingsz.png') },
        { src: require('../assets/pic_shenfen.png') },
      ],
      tipsFlag: false,
      addValue: [],
      addressData: [],
      cityID: '',
      showOwnerAddress: false,
      salesAreaOptions: [[...CONSTANTS.SALES_AREA.GUANGDONG]],
      salesCompanys: [],
      salesAreaCodeArr: [],
      isSelectModel: false,
      modelInfo: [],
      carLogos: utils.deepClone(CONSTANTS.BASE_BEAN.CAR_LOGO),
      powerOption: [[...CONSTANTS.POWER_OPTION]],
      carKindCodeShow: [],
      isPowerShow: false, // 是否是电动摩托车
      isExhaustScaleShow: false, // 是否是燃油摩托车
      licenseColorOptions: [utils.deepClone(CONSTANTS.LICENSE_COLOR_OPTIONS)] || [],
      carColorList:[utils.deepClone(CONSTANTS.carColorList)]
    }
  },
  computed: {
    ...mapGetters({
      getNewEnergyFlag: 'quote/getNewEnergyFlag',
    }),
    ...mapState({
      baseAddress: (state) => state.quote.baseAddress,
      quoteInfo: (state) => state.quote.quoteInfo,
      initQuoteInfo: (state) => state.quote.initQuoteInfo,
      insuredTips: (state) => state.insuredTips,
      applicantTips: (state) => state.applicantTips,
      flowId: (state) => state.flowId,
      deptCode: (state) => state.deptCode,
      cityList: (state) => state.cityList,
      cityGroup: (state) => state.cityGroup,
      isStartVideo: (state) => state.isStartVideo,
      switchList: (state) => state.quote.switchList,
      cacheRecordInfo: (state) => state.quote.cacheRecordInfo,
      popFrameInfo: state => state.quote.popFrameInfo,
      isHc: state => state.isHc,
      isNewCar: state => state.isNewCar
    }),
    POLICY_STYLES() {
      if (this.quoteInfo.base.busiAttrConfig.policyStyles) {
        let options = this.quoteInfo.base.busiAttrConfig.policyStyles.split(',') // [1,2]
        if (options.indexOf('1') != -1) {
          this.policyStyles = '1'
        } else if (options.indexOf('2') != -1) {
          this.policyStyles = '2'
        } else {
          this.policyStyles = options[0]
        }
        //// this.policyStyles = options[0];
        return [
          options.map((key) => {
            return {
              name: CONSTANTS.BASE_BEAN.POLICY_STYLES[key],
              value: `${key}`,
            }
          }),
        ]
      } else {
        return null
      }
    },
    purerange_placeholder() {
      let _v = this.carBeans.vehicle
      let _c =
        _v.ciModelCode == 'BXPTYXCL9999' &&
        _v.carKindCode == '100' &&
        ['纯电动', '燃料电池'].indexOf(_v.powerType) != -1
      let str = ''
      str = _c ? '投保车损险必录' : '请输入'
      return str
    },
    isGdNewCarShow() {
      // 逻辑同APP
      // 初登日期后9个月
      let singeinDates = new Date(
        this.carBeans.vehicle.singeinDate &&
          this.carBeans.vehicle.singeinDate.replace(/[-]/g, '/')
      )
      singeinDates.setMonth(singeinDates.getMonth() + 9)
      let singeinDatesQd =
        singeinDates.getFullYear() +
        '-' +
        (singeinDates.getMonth() + 1) +
        '-' +
        singeinDates.getDate()
      // 当前时间
      let nowTimes = new Date()
      let nowDates =
        nowTimes.getFullYear() +
        '-' +
        (nowTimes.getMonth() + 1) +
        '-' +
        nowTimes.getDate()
      let isGdInstitutions = this.deptCode.substring(0, 4) === '0102' // 报价机构是否广东
      let flag = false
      if (utils.daysBetween(singeinDatesQd, nowDates) >= 0) {
        if (this.switchList.newCarSwitch === '1' && isGdInstitutions) {
          flag = true
        }
      }
      return flag
    },
    isCarKindCodeShow() {
      return this.isPowerShow && this.switchList.selectCarSwitch !== "1" && this.switchList.motoCarKindCodeShow === '1'
    },
    isExhaustScale() {
      return this.isExhaustScaleShow && this.switchList.selectCarSwitch !== "1" && this.switchList.motoCarKindCodeShow === '1'
    },
    isMoto() {
      // 摩托车判断条件（根据业务需求调整）：
      // 1. 通过交强险类别码（MA/MB/MC）
      // console.log('交强险类别码', this.carBeans.vehicle.jqxClassId);
      const jqxClassId = this.carBeans.vehicle.jqxClassId;
      return ['MA', 'MB', 'MC'].includes(jqxClassId);
    },
    licenseColorArr: {
      get() {
      const vehicle = this.carBeans && this.carBeans.vehicle;
      const code = vehicle && vehicle.licenseColorCode;
        return code ? [code] : []; // 确保返回数组，而不是 undefined
      },
      set(newValue) {
        if (!this.carBeans) this.carBeans = {};
        if (!this.carBeans.vehicle) this.carBeans.vehicle = {};
        this.carBeans.vehicle.licenseColorCode = newValue ? newValue[0] : '';
      }
    },
    licenseTypeArr: {
      get() {
        const vehicle = this.carBeans && this.carBeans.vehicle;
        const code = vehicle && vehicle.licenseTypeCode;
        return code ? [code] : []; // 确保返回数组
      },
      set(newValue) {
        if (!this.carBeans) this.carBeans = {};
        if (!this.carBeans.vehicle) this.carBeans.vehicle = {};
        this.carBeans.vehicle.licenseTypeCode = newValue ? newValue[0] : '';
      }
    },
    carColorArr: {
        get() {
            const vehicle = this.carBeans && this.carBeans.vehicle;
            const code = vehicle && vehicle.carColor;
            return code ? [code] : []; // 确保返回数组
        },
        set(newValue) {
            if (!this.carBeans) this.carBeans = {};
            if (!this.carBeans.vehicle) this.carBeans.vehicle = {};
            this.carBeans.vehicle.carColor = newValue ? newValue[0] : '';
        }
    },
    licenseTypeOptions() {
      const options = this.isMoto
      ? utils.deepClone(CONSTANTS.MT_LICENSE_TYPE_OPTIONS)
      : utils.deepClone(CONSTANTS.LICENSE_TYPE_OPTIONS);
      return Array.isArray(options) ? [options] : []; // 确保是数组
    },
  },
  mounted() {
    if (CONSTANTS.DEPTCODE[this.deptCode] == 'BEIJING') {
      this.isBeiJing = true
      this.quoteInfo.beijing = true
    } else {
      this.quoteInfo.beijing = false
      this.quoteInfo.vehicle.certificateType = ''
    }
    if (CONSTANTS.DEPTCODE[this.deptCode] == 'SHANGHAI') {
      this.quoteInfo.shanghai = true
    } else {
      this.quoteInfo.shanghai = false
    }
    if (
      CONSTANTS.DEPTCODE[this.deptCode] == 'HEBEI' ||
      CONSTANTS.DEPTCODE[this.deptCode] == 'JIANGXI'
    ) {
      // this.addValue = [this.quoteInfo.owner.provinceCode,this.quoteInfo.owner.cityCode,this.quoteInfo.owner.areaCode]
      // 隐藏掉河北江西行驶证地址，黄天泽要求 230418
      this.$set(this, 'showOwnerAddress', false)
      if (
        this.quoteInfo.owner.ownerProvinceCode &&
        this.quoteInfo.owner.ownerCityCode &&
        this.quoteInfo.owner.ownerDistrictCode
      ) {
        this.addValue = [
          this.quoteInfo.owner.ownerProvinceCode,
          this.quoteInfo.owner.ownerCityCode,
          this.quoteInfo.owner.ownerDistrictCode,
        ]
      } else {
        this.addValue = []
      }
    } else {
      this.$set(this, 'showOwnerAddress', false)
    }
    if (this.cityList.length == 0) {
      $get.wxCityQuery().then((res) => {
        if (res.resultCode == '0') {
          this.addressData = res.result
          // utils.qqMapGeolocation().then(()=>{
          //     this.loadLocation()
          // })
        }
      })
    } else {
      this.addressData = this.cityList
      if (!this.value.length) {
        this.value = this.cityGroup
      }
    }
    this.carBeans = this.quoteInfo
    if (this.carBeans.base.companyCode.substr(0,4) === '0108') {
      // 个体工商户设置默认值
      this.carBeans.owner.personalBusinessFlag = this.carBeans.owner.personalBusinessFlag || '0';
    }
    this.carBeans.vehicle.chgOwnerFlag = this.transferCar ? '1' : '0'
    this.insuredMsg = this.insuredTips
    this.applicantMsg = this.applicantTips
    // 获取缓存的地址
    this.getAddress()
    this.isLoaded = true
    // if (this.isStartVideo === false) {
    //   utils.startVideo(1, this.flowId, (isSuccess) => {
    //     if (isSuccess) {
    //       this.$store.commit('setIsStartVideo', true)
    //       utils.createOperationVideo('LOAD_PAGE', '填写信息')
    //     }
    //   })
    // }
    this.queryPopFrameInfo(this.carBeans.base.companyCode.substring(0,4))
    if (!this.carBeans.owner.occupationCode) {
      this.carBeans.owner.occupationCode = '01'
      this.carBeans.owner.occupationName = '一般职业人员'
    }
    // 如果是纯电摩托车
    if (this.carBeans.vehicle.powerTypeCode === "1" && this.carBeans.vehicle.power) {
      this.isCarKindCodeShow = true;
    }
  },
  watch: {
    transferCar: {
      handler(newName) {
        this.carBeans.vehicle.chgOwnerFlag = newName ? '1' : '0'
      },
      immediate: true,
      deep: true,
    },
    'carBeans.vehicle.salesAreaCode': {
      handler(newVal) {
        this.salesAreaCodeArr = newVal ? [newVal] : [] // 同步销售公司所在地
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    StatusBar,
    Datetime,
    Group,
    CheckIcon,
    PopupPickerSelector,
    XSwitch,
    PopupPicker,
    XInput,
    XDialog,
    XAddress,
    SearchInput,
    ImgRecord,
    AlertToShop,
    [Popup.name]: Popup,
  },
  vuerify: {
    'carBeans.owner.name': {
      test: /\S/,
      message: '请输入车主姓名',
    },
    'carBeans.owner.mobilePhone': [
      {
        test: /\S/,
        message: '请输入车主联系电话',
      },
      {
        test: /^([1][3-9][0-9]{9})$|^((\d){3}(\*){4}(\d){4})$/,
        message: '车主联系电话输入有误',
      },
    ],
    'address': [
        {
          test: function(){
            // 如果投保人被保人都不同车主，则不用输入地址
            if (this.insuredMsg && this.applicantMsg){
              return true
            } else {
              return this.address
            }
          },
          message: '请输入地址'
        },
        {
          test: function(){
            // 如果投保人被保人都不同车主，则不用输入地址
            if (this.insuredMsg && this.applicantMsg){
              return true
            } else {
              const checkResult = utils.checkAddress({
                address: this.address
              })
              if (!checkResult.chkres) {
                return false
              } else {
                return true
              }
            }
          },
          message: '地址不能少于6个汉字或12个字符！'
        }
    ],
    'carBeans.owner.identifyNumber': [
      {
        test: /\S/,
        message: '请输入车主身份证号',
      },
      {
        test: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/,
        message: '车主身份证号格式错误',
      },
    ],
    'carBeans.owner.identifyExpiry': [
      {
        test: /\S/,
        message: '请选择车主证件有效日期',
      },
    ],
    'carBeans.owner.occupationCode': [
      {
        test: /\S/,
        message: '请选择车主职业',
      },
    ],
    'carBeans.vehicle.frameNo': [
      {
        test: /\S/,
        message: '请输入车架号',
      },
      {
        test: function() {
          if (this.carBeans.vehicle.frameNo) {
            let vhls = this.carBeans.vehicle.frameNo
            let isReach =
              vhls.indexOf('I') + vhls.indexOf('O') + vhls.indexOf('Q')
            if (!/^[a-z0-9A-Z-_]+$/.test(vhls) || isReach > -3) {
              return false
            } else {
              return true
            }
          }
        },
        message: '您的车架号输入不正确',
      },
    ],
    'carBeans.vehicle.engineNo': {
      test: /\S/,
      message: '请输入发动机号',
    },
    'carBeans.vehicle.singeinDate': [
      {
        test: function() {
          if (this.isNewCar) return true
          if (!/\S/.test(this.carBeans.vehicle.singeinDate)) {
            return false
          } else {
            return true
          }
        },
        // test: /\S/,
        message: '请选择车辆注册日期',
      },
      {
        test: /^(((((1[6-9]|[2-9]\d)\d{2})-(0?[13578]|1[02])-(0?[1-9]|[12]\d|3[01]))|(((1[6-9]|[2-9]\d)\d{2})-(0?[13456789]|1[012])-(0?[1-9]|[12]\d|30))|(((1[6-9]|[2-9]\d)\d{2})-0?2-(0?[1-9]|1\d|2[0-8]))|(((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))-0?2-29)))?$/,
        message: '您的车辆注册日期格式不正确',
      },
    ],
    'carBeans.vehicle.brandName': {
      test: /\S/,
      message: '请选择车型',
    },
    'carBeans.vehicle.maxDesignSpeed': [
      {
        test(value) {
          if (!this.isMoto) return true;      // 非摩托车跳过
          if (!value || value === '0') return false; // 空值或0均无效
          return /^[1-9]\d*$/.test(value);    // 正整数校验
        },
        message: '最高设计时速必须为大于0的整数' 
      },
    ],
    'carBeans.vehicle.carColor': [
      {
        test(value) {
          const carColorSwitch = this.switchList && this.switchList.carColorSwitch;
          if (carColorSwitch === '1') {
              return /\S/.test(value); // 开关为1时校验非空
          } else {
              return true; // 开关非1时直接通过
          }
        },
        message: '请选择车身颜色'
      }
    ],
    'carBeans.applicant.email': [
      {
        test: /\S/,
        message: '请输入电子邮箱',
      },
      {
        test: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@([a-zA-Z0-9]*[-_]?[a-zA-Z0-9]+)+[\\.][A-Za-z]{2,3}([\\.][A-Za-z]{2,3})?$/,
        message: '电子邮箱格式错误',
      },
    ],
    'carBeans.vehicle.carKindCodeShow': [
      {
        test: function() {
          if (this.isCarKindCodeShow) {
            if (this.carKindCodeShow.length) {
              return true
            }
            return false
          }
          return true
        },
        message: '请选择车辆类型',
      }
    ],
    'carBeans.vehicle.exhaustScale': [
      {
        test: function() {
          if (this.isExhaustScale) {
            if (this.carBeans.vehicle.exhaustScale > 0 && this.carBeans.vehicle.exhaustScale < 99) {
              return true
            } else {

            }
            return false
          }
          return true
        },
        message: '请输入排量，单位升',
      }
    ]
  },
  methods: {
    ...mapMutations({
      setQuoteInfo: 'quote/setQuoteInfo',
      setPolicyStyles: 'quote/setPolicyStyles',
      setCacheRecordInfo: 'quote/setCacheRecordInfo',
      setBaseAddress: 'quote/setBaseAddress'
    }),
    ...mapActions({
      officialApply: 'quote/officialApply',
      queryHolidayInfo: 'quote/queryHolidayInfo',
      queryPopFrameInfo: 'quote/queryPopFrameInfo'
    }),
    // 最高时速实时处理输入（可选）
    handleSpeedChange(val) {
      // 自动清除非数字字符
      this.carBeans.vehicle.maxDesignSpeed = val.replace(/[^\d.]/g, '');
      this.changelicenseType()
    },
    // 获取缓存的地址
    getAddress() {
      // 如果被保人同车主或者投保人同车主
      if (!this.insuredMsg || !this.applicantMsg) {
        // 如果被保人同车主
        if (!this.insuredMsg) {
          this.address = this.quoteInfo.insured.address || this.baseAddress
        }
        // 如果投保人同车主
        if (!this.applicantMsg) {
          this.address = this.quoteInfo.applicant.address || this.baseAddress
        }
      } else {
        this.address = this.baseAddress || ''
      }
    },
    // 缓存地址到vuex
    cacheAddress() {
      this.setBaseAddress(this.address)
    },
    getIdInfo(value) {
      // 身份证识别生日
      if (value.length == 15 || value.length == 18) {
        this.carBeans.owner.birthday = utils.getIdCardInfo(value).birthday
        let newDate = new Date();
        let today = utils.beautyFormatDate(newDate, 'yyyy-mm-dd')
        let birthday = utils.beautyFormatDate(this.carBeans.owner.birthday, 'yyyy-mm-dd');
        this.carBeans.owner.age = utils.yearsBetween(today, birthday, false);
      }
    },
    checkIdentifyExpiry(val) {
      // 校验证件有效期
      if (
        this.carBeans.owner.birthday &&
        this.carBeans.owner.identifyType === '01'
      ) {
        let newDate = new Date()
        let today = utils.beautyFormatDate(newDate, 'yyyy-mm-dd')
        let birthday = utils.beautyFormatDate(
          this.carBeans.owner.birthday,
          'yyyy-mm-dd'
        )
        let age = utils.yearsBetween(today, birthday, false)
        let futureYears = newDate.getFullYear() + 20
        let Expiry = new Date().setFullYear(futureYears)
        let identifyExpiry = this.carBeans.owner.identifyExpiry
        if (age && age < 45) {
          if (this.carBeans.owner.identifyExpiry == '9999-12-31') {
            this.carBeans.owner.identifyExpiry = ''
            this.carBeans.owner.identifyLongValid = '0'
            Toast(`小于45周岁，证件有效不能选择长期有效`)
            return false
          }
          if (
            Expiry &&
            identifyExpiry &&
            new Date(identifyExpiry.replace(/[-]/g, '/')) > Expiry
          ) {
            this.carBeans.owner.identifyExpiry = ''
            this.carBeans.owner.identifyLongValid = '0'
            Toast(`小于45周岁，证件有效期不能大于20年`)
            return false
          }
        }
      }
    },
    // longTermExp(val){
    //     // 设置长期有效
    //     this.carBeans.owner.identifyExpiry = '9999-12-31';
    //     this.carBeans.owner.identifyLongValid = '1';
    //     this.checkIdentifyExpiry(val);
    // },
    changeExp(val) {
      // 设置证件有效期
      let today = utils.beautyFormatDate(new Date(), 'yyyy-mm-dd')
      let identifyExpiry = this.carBeans.owner.identifyExpiry
      if (
        new Date(identifyExpiry.replace(/[-]/g, '/')) <
        new Date(today.replace(/[-]/g, '/'))
      ) {
        Toast(`证件有效期已过期，请核实`)
        return false
      }
      if (this.carBeans.owner.identifyExpiry != '9999-12-31') {
        this.carBeans.owner.identifyLongValid = '0'
      } else if (this.carBeans.owner.identifyExpiry === '9999-12-31') {
        this.carBeans.owner.identifyLongValid = '1'
        this.checkIdentifyExpiry(val)
      }
    },
    changeTime(value) {},
    changeDate(value) {},
    chgOwnerDate(value) {},
    changeType(value) {
      if (value == '01') {
        this.certificateNo = '新车购置发票号'
        this.certificateDate = '购车发票开具日期'
      } else {
        this.certificateNo = '车辆来历凭证编号'
        this.certificateDate = '来历凭证开具日期'
      }
    },
    imgUploadVailde() {
      if (!this.$refs.ownerRef.recordInfo.owner.justSrc) {
        Toast('请上传身份证正面')
        return false
      }
      if (!this.$refs.ownerRef.recordInfo.owner.backSrc) {
        Toast('请上传身份证背面')
        return false
      }
      if (!this.$refs.carInfoRef.recordInfo.vehicle.justSrc) {
        Toast('请上传行驶证正面')
        return false
      }
      if (!this.$refs.carInfoRef.recordInfo.vehicle.backSrc) {
        Toast('请上传行驶证背面')
        return false
      }
      return true
    },
    popTip() {
      const {prompt, isIntercept} = this.popFrameInfo
      // isIntercept: 1完全拦截，0不拦截
      const pass = isIntercept === '1' ? false : true
      return new Promise((resolve) => {
        this.$vux.alert.show({
          title: '温馨提示',
          content: prompt,
          onHide () {
            resolve(pass)
          }
        })
      })
    },
    async handleSubmit() {
      // 230626新增工作日可投保开关
      if (this.switchList.weekdayInsure === '1') {
        let canInsure = false;
        let date = utils.beautyFormatDate(new Date(), 'yyyy-mm-dd');
        // 1 2 3 4 5 % 6 = 1 2 3 4 5 工作日 6 0 % 6 = 0 0 周末
        // let isWeekDay = new Date().getDay() % 6 !== 0
        let isWeekDay = await this.queryHolidayInfo(date);
        let isWorkTime = utils.checkAuditTime('09:00', '11:30') || utils.checkAuditTime('13:30', '16:30');
        if (isWeekDay && isWorkTime) {
          canInsure = true;
        }
        if (!canInsure) {
          this.$vux.alert.show({
            title: '温馨提示',
            content: '信息录入有误，请核实信息。'
          })
          return
        }
      }
      if(this.switchList.restrictQuoteSwitch === '1'){
        this.$vux.alert.show({
            title: '温馨提示',
            content: '服务异常/繁忙'
        })
        return
      }
      let jqxClassId = this.carBeans.vehicle.jqxClassId;
      let motoCheckArr = ['MA','MB','MC'];
      // 非摩托车投保管控
      if(jqxClassId && !motoCheckArr.includes(jqxClassId) && this.switchList.notMotoInsureSwitch !== '1'){
          if(this.$refs.alertRef && this.$refs.alertRef.show) {
              this.$refs.alertRef.show()
              return
          }
      }
      // 摩托车投保管控
      if(jqxClassId && motoCheckArr.includes(jqxClassId) && this.switchList.motoInsureSwitch !== '1'){
          if(this.$refs.alertRef && this.$refs.alertRef.show) {
              this.$refs.alertRef.show()
              return
          }
      }
      // 行协】河南货车便民投保链接管控
      if (this.isHc) {
          if (['HA','HB','HC','HD'].includes(jqxClassId)) {
              this.carBeans.vehicle.carKindCode = '200'
          }else if (['GA','GB','GC','GD'].includes(jqxClassId)) {
              this.carBeans.vehicle.carKindCode = '200'
          }
          let dict = {'HA':'21', 'HB':'22', 'HC':'23', 'HD':'24',
                      'GA':'25', 'GB':'26', 'GC':'27', 'GD':'28'}
          let carKindCodeShow = dict[jqxClassId];
          this.carBeans.vehicle.carKindCodeShow = carKindCodeShow;
          let vehicleCategory = utils.VEHICLECATEGORY[carKindCodeShow]
          this.carBeans.vehicle.vehicleCategory = vehicleCategory?Object.keys(vehicleCategory)[0] :'' ;
          this.carBeans.base.busiAttrConfig.useNatures = '01' // 营业
      }
      if (this.isHc && !['HA','HB','HC','HD','GA','GB','GC','GD'].includes(jqxClassId)) {
        this.$vux.alert.show({
            title: '温馨提示',
            content: '本便民链接仅支持营业货车投保，您当前输入的车辆不在此类型，如需投保或有疑问，请访问线下门店咨询，感谢您的谅解与支持！'
          })
          return
      }
      // 影像必传校验
      if (!this.imgUploadVailde()) return
      // 缓存上传的图片到vuex
      const myRecordInfo = utils.deepClone(this.cacheRecordInfo)
      myRecordInfo.owner = utils.deepClone(this.$refs.ownerRef.recordInfo.owner)
      myRecordInfo.vehicle = utils.deepClone(
        this.$refs.carInfoRef.recordInfo.vehicle
      )
      this.setCacheRecordInfo(myRecordInfo)
      //提交前先对carBeans数据做格式化处理
      for (let props in this.carBeans) {
        this.carBeans[props] = utils.textTrim(this.carBeans[props])
      }
      // 新车销售赋值 逻辑同APP
      if (!this.isGdNewCarShow) {
        delete this.carBeans.vehicle.salesCompany
        delete this.carBeans.vehicle.salesAreaCode
        delete this.carBeans.vehicle.salesFoursFlag
      } else {
        if (!this.carBeans.vehicle.salesFoursFlag) {
          this.carBeans.vehicle.salesFoursFlag = '0'
        }
      }
      this.carBeans.owner.identifyNumber = this.carBeans.owner.identifyNumber.toUpperCase()
      this.carBeans.insured.identifyNumber = this.carBeans.insured.identifyNumber.toUpperCase()
      this.carBeans.applicant.identifyNumber = this.carBeans.applicant.identifyNumber.toUpperCase()
      this.carBeans.vehicle.frameNo = this.carBeans.vehicle.frameNo.toUpperCase()
      this.carBeans.vehicle.singeinDate = utils.formatSingeinDate(
        this.carBeans.vehicle.singeinDate
      )
      this.carBeans.riskList.forEach((element) => {
        if (
          [CONSTANTS.XNY_RISK_CODE, CONSTANTS.SY_RISK_CODE].includes(
            element.riskCode
          )
        ) {
          // TODO 新旧能源切换，需变更商业险的riskCode，否则报价页获取不到对应的险别
          let _sy_code = this.getNewEnergyFlag
            ? CONSTANTS.XNY_RISK_CODE
            : CONSTANTS.SY_RISK_CODE
          element.riskCode = _sy_code
        }
      })
      this.carBeans.base.insuredProduct =
        this.carBeans.vehicle.carKindCode === '400'
          ? '1'
          : this.getNewEnergyFlag
          ? '3'
          : '0' // 投保产品 0机动车 1摩托车 3新能源
      //然后再校验数据格式有效性
      if (this.$vuerify.check()) {
        if(this.switchList.carColorSwitch === '1' && !this.carBeans.vehicle.carColor){
            Toast('请选择车身颜色');
            return
        }
        if (this.isGdNewCarShow && !this.carBeans.vehicle.salesCompany) {
          Toast('请录入新车销售公司名称')
          return
        }
        if (this.isGdNewCarShow && !this.carBeans.vehicle.salesFoursFlag) {
          Toast('请选择新车是否4S店销售')
          return
        }
        if (this.isGdNewCarShow && !this.carBeans.vehicle.salesAreaCode) {
          Toast('请录入销售公司所在城市')
          return
        }
        if (this.isBeiJing && !this.carBeans.vehicle.certificateNo) {
          Toast('请输入' + this.certificateNo)
          return
        }
        if (this.isBeiJing && !this.carBeans.vehicle.certificateDate) {
          Toast('请输入' + this.certificateDate)
          return
        }
        if (this.transferCar && !this.carBeans.vehicle.chgOwnerDate) {
          Toast('请选择过户时间')
          return
        }
        if (this.showOwnerAddress && !this.addValue.length) {
          Toast('请选择行驶证地址')
          return
        }
        if (this.showOwnerAddress && !this.carBeans.owner.ownerAddress) {
          Toast('请输入行驶证详细地址')
          return
        }
        if (
          this.showOwnerAddress &&
          this.carBeans.owner.ownerAddress.length < 5
        ) {
          Toast('行驶证详细地址不少于5位数')
          return
        }
        if (
          this.showOwnerAddress &&
          this.carBeans.owner.ownerAddress.length > 50
        ) {
          Toast('行驶证详细地址不超过50位数')
          return
        }
        this.cacheAddress()
        if (!this.insuredMsg) {
          this.carBeans.insured.name = this.carBeans.owner.name
          this.carBeans.insured.phone = this.carBeans.owner.mobilePhone
          this.carBeans.insured.identifyNumber = this.carBeans.owner.identifyNumber
          this.carBeans.insured.occupationCode = this.carBeans.owner.occupationCode
          this.carBeans.insured.occupationName = this.carBeans.owner.occupationName
          this.carBeans.insured.country = this.carBeans.owner.country
          this.carBeans.insured.identifyExpiry = this.carBeans.owner.identifyExpiry
          this.carBeans.insured.certiStartDate = this.carBeans.owner.certiStartDate;
          this.carBeans.insured.certiEndDate = this.carBeans.owner.certiEndDate;
          this.carBeans.insured.identifyLongValid = this.carBeans.owner.identifyLongValid
          this.carBeans.insured.birthday = this.carBeans.owner.birthday
          this.carBeans.insured.age = this.carBeans.owner.age
          this.carBeans.insured.address = this.address
        }
        if (!this.applicantMsg) {
          this.carBeans.applicant.name = this.carBeans.owner.name
          this.carBeans.applicant.phone = this.carBeans.owner.mobilePhone
          this.carBeans.applicant.identifyNumber = this.carBeans.owner.identifyNumber
          this.carBeans.applicant.occupationCode = this.carBeans.owner.occupationCode
          this.carBeans.applicant.occupationName = this.carBeans.owner.occupationName
          this.carBeans.applicant.country = this.carBeans.owner.country
          this.carBeans.applicant.identifyExpiry = this.carBeans.owner.identifyExpiry
          this.carBeans.applicant.certiStartDate = this.carBeans.owner.certiStartDate;
          this.carBeans.applicant.certiEndDate = this.carBeans.owner.certiEndDate;
          this.carBeans.applicant.identifyLongValid = this.carBeans.owner.identifyLongValid
          this.carBeans.applicant.birthday = this.carBeans.owner.birthday
          this.carBeans.applicant.age = this.carBeans.owner.age;
          this.carBeans.applicant.address = this.address
        }
        if (!this.isBeiJing) {
          this.carBeans.vehicle.certificateType = ''
        }
        this.setQuoteInfo(utils.deepClone(this.carBeans))
        // 存储电子保单到store 报价时拼装
        this.setPolicyStyles(this.policyStyles)
        let pass = true
        // 如果是摩托车，并且后端有返回弹框提示内容
        if (this.carBeans.base.insuredProduct === '1' && this.popFrameInfo && this.popFrameInfo.prompt) {
          pass = await this.popTip()
        }
        if (!pass) {
          return
        }
        //  保存流
        this.officialApply({
          showLoading: true,
          closeLoading: true,
        })
          .then(() => {
            if (this.getNewEnergyFlag) {
              this.$router.push({ name: 'AdujustInsuranceEnergy' })
            } else {
              this.$router.push({ name: 'AdujustInsurance' })
            }
          })
          .catch((err) => {
            Toast(err)
          })
      } else {
        for (let item in this.$vuerify.$errors) {
          let errMsg
          if (typeof this.$vuerify.$errors[item] == 'string') {
            errMsg = this.$vuerify.$errors[item]
          } else {
            errMsg = this.$vuerify.$errors[item][0]
          }
          Toast(errMsg)
          break
        }
      }
    },
    sameOwner(type) {
      const myRecordInfo = utils.deepClone(this.cacheRecordInfo)
      myRecordInfo.owner = utils.deepClone(this.$refs.ownerRef.recordInfo.owner)
      myRecordInfo.vehicle = utils.deepClone(
        this.$refs.carInfoRef.recordInfo.vehicle
      )
      this.setCacheRecordInfo(myRecordInfo)
      this.cacheAddress()
      this.$router.push({
        path: '/owner_same_ocr',
        name: 'OwnerSameOcr',
        params: {
          type: type,
        },
      })
    },
    // toOccupationList(type){
    //     this.$router.push({
    //         path: '/occupation_list',
    //         name: 'OccupationList',
    //         params: {
    //             type: type
    //         }
    //     })
    // },
    // toModel(){
    //     if(this.switchList.selectCarSwitch!=='1'){
    //         return;
    //     }
    //     this.setQuoteInfo(this.carBeans);
    //     let vhls=this.carBeans.vehicle.frameNo;
    //     if(!vhls){
    //         Toast('请输入车架号');
    //         return
    //     }else {
    //         let isReach = vhls.indexOf("I") + vhls.indexOf("O") + vhls.indexOf("Q");
    //         console.log(isReach);
    //         if(!/^[a-z0-9A-Z-_]+$/.test(vhls) || isReach > -3){
    //             Toast('您的车架号输入不正确');
    //             return
    //         }
    //     }

    //     this.$router.push({
    //         path: '/vehicle_model',
    //         name: 'VehicleModel'
    //     })
    // },
    // onSelect(card){
    //     card=='1'?this.tipsFlag=true:this.tipsFlag=false;
    //     this.showDialog=true;
    // },
    // upImg(tips){
    //     let card=tips?'1':'2';
    //     let e=window.event;
    //     if (e.target.files.length < 1) {
    //         return;
    //     }
    //     let file = e.target.files[0],
    //         type = file.type; //"image/png"
    //     let reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     let _this = this;
    //     reader.onload = function(e) {
    //         let res = e.target.result;
    //         if (type.indexOf('image') > -1) {
    //             _this.zipImgUpload(file, res, card); //压缩上传
    //         } else {
    //             Toast('请选择图片上传');
    //         }
    //     };
    // },
    // zipImgUpload(file, res,card) {
    //     //压缩上传图片 imagePath
    //     let Upload = new SnkUpload(),
    //         _this = this;
    //     Upload.compress({
    //         url:'/Interface_Cluster/HttpUploadAction',
    //         chunckCount: 1, //暂不分片，待后端支持
    //         quality: 0.3,
    //         file,
    //         getCompressedFileInfo(info) {
    //             // 可以获取到md5
    //             // 可以判断 文件大小 然后动态设置 info.instance.chunckCount = n;
    //             // info.instance.chunckCount = 1;
    //             console.log(info);
    //             // params.File = info.base64Str;
    //             _this.uploadFile(info,card);
    //         },
    //         success(params) {},
    //         error(params) {
    //             console.log(params);
    //             Toast('证件上传失败，请重新上传');
    //         }
    //     });
    // },
    // uploadFile(info,card) {
    //     let _this = this;
    //     let base64=info.base64Str.split('base64,')[1];
    //     $http.ocrHandle({
    //         data:{
    //             type:card,
    //             imgData:base64
    //         }
    //     }).then(res => {
    //         if(res.resultCode=='0'){
    //             if(card=='1'){//行驶证
    //                 let frameNo=res.result.frameNo ? res.result.frameNo.trim().toUpperCase() : '';
    //                 let engineNo=res.result.engineNo ? res.result.engineNo.trim() : '';
    //                 let brandName=res.result.brandName ? res.result.brandName.trim() : '';
    //                 let licenseNo=res.result.licenseNo ? res.result.licenseNo.trim() : '';
    //                 _this.carBeans.vehicle.frameNo=frameNo;
    //                 let singeinDate=res.result.singeinDate ? utils.formatSingeinDate(res.result.singeinDate) : '';
    //                 // this.toModel();
    //                 this.queryVehicleModel('OCR',licenseNo,frameNo,brandName)
    //             }else{//车主身份证
    //                 _this.carBeans.owner.name=res.result.name ? res.result.name.trim() : '';
    //                 _this.carBeans.owner.identifyNumber=res.result.idNumber ? res.result.idNumber.trim().toUpperCase() : '';
    //                 _this.carBeans.owner.birthday=res.result.birthday ? utils.transDate(res.result.birthday.trim()) : '';
    //             }
    //         }else{
    //             Toast(res.errorMsg);
    //         }

    //     })
    // },
    setOwnerInfo(onwerInfo) {
      //OCR车主信息回填
      this.carBeans.owner.name = onwerInfo.name
      this.carBeans.owner.identifyNumber = onwerInfo.identifyNumber
      this.carBeans.owner.birthday = onwerInfo.birthday
      const dateReg = /^(\d{4})\.(\d{2})\.(\d{2})-(\d{4})\.(\d{2})\.(\d{2})$/
      if (dateReg.test(onwerInfo.identifyExpiry)) {
        this.carBeans.owner.identifyExpiry = onwerInfo.identifyExpiry
          .split('-')[1]
          .split('.')
          .join('-');
        this.carBeans.owner.certiEndDate = onwerInfo.identifyExpiry
        .split('-')[1]
        .split('.')
        .join('-');
        this.carBeans.owner.certiStartDate = onwerInfo.identifyExpiry
        .split('-')[0]
        .split('.')
        .join('-');
      } else {
        this.carBeans.owner.identifyExpiry = onwerInfo.identifyExpiry || ''
      }
      const birthday = utils.beautyFormatDate(
        this.carBeans.owner.birthday,
        'yyyy-mm-dd'
      )
      this.carBeans.owner.age = utils.yearsBetween(birthday)
      this.carBeans.owner.identifyType = '01'
      this.carBeans.owner.occupationCode = '01'
      this.carBeans.owner.occupationName = '一般职业人员'
      this.getIdInfo(onwerInfo.identifyNumber)
      if (onwerInfo.identifyExpiry) {
        this.changeExp(onwerInfo.identifyExpiry)
      }
    },
    setCarInfo(carInfo, card) {
      //OCR车辆信息回填
      let { licenseNo, frameNo, brandName, engineNo, singeinDate } = carInfo
      this.carBeans.vehicle.frameNo = frameNo
      this.carBeans.vehicle.licenseNo = licenseNo
      this.carBeans.vehicle.brandName = brandName
      this.carBeans.vehicle.engineNo = engineNo
      this.carBeans.vehicle.singeinDate = singeinDate
      if (card === '1') {
        this.queryVehicleModel('OCR', licenseNo, frameNo, brandName)
      }
    },
    onShadowChange(ids, names) {
      this.cityID = utils.deepClone(ids).pop()
      this.carBeans.owner.ownerProvinceCode = ids[0]
      this.carBeans.owner.ownerCityCode = ids[1]
      this.carBeans.owner.ownerDistrictCode = ids[2]
    },
    onShadowHide(status) {
      if (status) {
        let [ownerProvinceCode, ownerCityCode, ownerDistrictCode] = this.value
        this.cityID = utils.deepClone(this.value).pop()
        this.carBeans.owner.ownerProvinceCode = ownerProvinceCode
        this.carBeans.owner.ownerCityCode = ownerCityCode
        this.carBeans.owner.ownerDistrictCode = ownerDistrictCode
      }
    },
    onChangeSalesAreaCode(value) {
      let [salesAreaCode] = value
      this.carBeans.vehicle.salesAreaCode = salesAreaCode
    },
    // 修改车辆类型
    onChangePower(value) {
        this.carBeans.vehicle.carKindCodeShow = value[0];
        switch (value[0]) {
            case '74':
                this.carBeans.vehicle.power = "3";
                // this.carBeans.vehicle.maxDesignSpeed = "25";
                break;
            case '75':
                this.carBeans.vehicle.power = "6";
                // this.carBeans.vehicle.maxDesignSpeed = "60";
                break;
            case '76':
                this.carBeans.vehicle.power = "9";
                // this.carBeans.vehicle.maxDesignSpeed = "80";
                break;
            default:
                break;
        }
    },
    querySearchAsync(salesCompany) {
      // 查询新车销售公司名称
      let tempSaleCompany = this.carBeans.vehicle.salesCompany // 预留值作对比
      this.carBeans.vehicle.salesCompany = salesCompany // 同步值
      if (salesCompany === undefined || salesCompany.trim() === '') {
        this.salesCompanys = []
        return
      }
      if (salesCompany === tempSaleCompany) {
        return
      }
      $http
        .queryTempSalesCompany({
          data: {
            salesCompany: salesCompany,
            timestamp: new Date().getTime(),
          },
        })
        .then((res) => {
          let _result = []
          if (res.resultCode === '0') {
            _result = res.result
          }
          this.salesCompanys = _result
        })
    },
    handleSelect(param) {
      this.carBeans.vehicle.salesAreaCode = param.salesAreaCode || ''
      this.carBeans.vehicle.salesCompany = param.salesCompany || ''
      this.carBeans.vehicle.salesFoursFlag = param.salesFoursFlag || ''
    },
    // 号牌颜色、号牌种类赋值处理
    changelicenseType (){
        let LicensePlateHelper = new utils.LicensePlateHelper(this.carBeans.vehicle);
        let licenseType = LicensePlateHelper.getPlateColor();
        this.carBeans.vehicle.licenseColorCode = licenseType && licenseType.licenseColorCode;
        this.carBeans.vehicle.licenseTypeCode = licenseType && licenseType.licenseTypeCode;
        // console.log('号牌颜色、号牌种类赋值处理',this.carBeans.vehicle.licenseColorCode, this.carBeans.vehicle.licenseTypeCode);
    },
    selectModel(vhl) {
      this.carBeans.vehicle = utils.mergeObj(
        this.carBeans.vehicle,
        vhl,
        utils.deepClone(CONSTANTS.CAR_BEANS.vehicle)
      );
      const jqSyClass = vhl.jqxClassId ? vhl.jqxClassId : vhl.syxClassId;
      let isMoto = ['MA','MB','MC'].includes(jqSyClass);
      // 新接口查车
      if(this.switchList.VehicleMode === '1') {
          if(vhl.carKindCode === '400' || isMoto) {
              // 如果是摩托车的话
              this.setMotoVehicle(vhl);
          } else {
              const carkind = utils.setOtherInfo(this.carBeans.vehicle);
              this.carBeans.vehicle.carKindCodeShow = carkind.carKindCodeShow;
              this.carBeans.vehicle.carKindCode = carkind.carKindCode;
              // 判断是否是新能源
              this.carBeans.base.insuredProduct = vhl.newEnergyFlag === '1' ? '3' : '0';
          }
      } else {
        if (!vhl.carKindCodeShow && !vhl.carKindCode) {
          // 处理车辆使用性质转换失败问题
          this.carBeans.vehicle.carKindCodeShow = '11';
          // 判断是否是新能源
          this.carBeans.base.insuredProduct = vhl.newEnergyFlag === '1' ? '3' : '0';
        } else if(vhl.carKindCode === '400' || isMoto) {
            // 如果是摩托车的话
            this.setMotoVehicle(vhl);
        } else {
          this.carBeans.vehicle.carKindCodeShow =
            CONSTANTS.BASE_BEAN.CLASSIDTOCARKINDSHOW[
              this.carBeans.vehicle.jqxClassId
            ];
          // 判断是否是新能源
          this.carBeans.base.insuredProduct = vhl.newEnergyFlag === '1' ? '3' : '0';  
        }
      }
      this.changelicenseType()
      this.setQuoteInfo(this.carBeans)
      //弹框消失
      this.$set(this, 'isSelectModel', false)
    },
    // onBlurFrameNo(value,$even){
    //     this.queryVehicleModel('','','','')
    // },
    // onChangeFrameNo(value){
    //     //清空车型数据
    //     if(this.switchList.selectCarSwitch==='1'){
    //         return;
    //     }
    //     let licenseNo = this.carBeans.vehicle.licenseNo;
    //     let vehicle= utils.mergeObj({},this.carBeans.vehicle,utils.deepClone(CONSTANTS.CAR_BEANS.vehicle));
    //     this.carBeans.vehicle = vehicle;
    //     this.carBeans.vehicle.licenseNo = licenseNo;
    //     this.carBeans.vehicle.frameNo = value;
    //     this.setQuoteInfo(this.carBeans);
    // },
    queryVehicleModel(type, licenseNo, frameNo, brandName) {
      let data, selectCarApi ; // 参数和接口
      // 开关为开调用这个
      if(this.switchList.VehicleMode === '1') {
          selectCarApi = $http.mergerVehicleModel;
          data = {
              frameNo: frameNo || this.carBeans.vehicle.frameNo,
              producutCode: this.isHc?this.carBeans.base.insuredProduct :'1',
              companyCode: this.carBeans.base.companyCode,
              engineNo: this.carBeans.vehicle.engineNo,
              sysSource: "eautoshop",
              registerDate: this.carBeans.vehicle.singeinDate,
              licenseNo: licenseNo || this.carBeans.vehicle.licenseNo,
              modelCode: this.carBeans.vehicle.modelCode,
              modelName: brandName || this.carBeans.vehicle.modelName,
              riskCode: '',
              queryInd: '',
              carNewOldFlag: this.carBeans.vehicle.carNewOldFlag,
          }
      } else {
          // 否则调用这个
          selectCarApi = $http.officialVehicleModel;
          if(type){
              data = {
                  companyCode:this.carBeans.base.companyCode,
                  frameNo:frameNo,
                  licenseNo: licenseNo,
                  modelCode:'',
                  modelName:brandName
              }
          }else{
              data = {
                  companyCode:this.carBeans.base.companyCode,
                  frameNo:this.carBeans.vehicle.frameNo,
                  licenseNo: this.carBeans.vehicle.licenseNo,
                  modelCode:this.carBeans.vehicle.modelCode,
                  modelName:this.carBeans.vehicle.brandName
              }
          }
      }
      if(!data.frameNo){
          return
      }
      selectCarApi({
          data: data,
        })
        .then((res) => {
          if (res.resultCode == '0') {
            // 因返回数据不一，同步一下
            let carList;
            if(this.switchList.VehicleMode === '1') {
                carList = res.result && res.result.carList;
            } else {
                carList = res.result;
            }
            let that=this;
            carList.forEach(item1 => {
                Object.keys(that.carLogos).map(key => {
                    if(item1.brandName.indexOf(key)!=-1){
                        item1.url=that.carLogos[key];
                    }
                })
            })

            window.setTimeout(function() {
              that.$set(that, 'modelInfo', carList)
            }, 0)

            if (carList && carList.length && carList.length === 1) {
              that.selectModel(carList[0])
            } else if (carList && carList.length && carList.length > 1) {
              that.$set(that, 'isSelectModel', true)
              //弹框消失
            } else if (res.errorMsg) {
              Toast(res.errorMsg)
            } else {
              Toast('抱歉，您录入的车架号无法查询出车型数据，请检查')
            }
          } else {
            Toast('抱歉，您录入的车架号无法查询出车型数据，请检查')
          }
        })
        .catch((err) => {
          Toast(err)
        })
    },
    // 设置摩托车车辆信息
    setMotoVehicle(vhl) {
      this.carBeans.base.insuredProduct = '1';
      this.carBeans.vehicle.carKindCode = '400';
      // 先将两个展示关闭
      this.isExhaustScaleShow = false;
      this.isPowerShow = false;
      // 燃油摩托车
      if (vhl.powerTypeCode === '0') {
          this.isExhaustScaleShow = vhl.exhaustScale ? false : true; // 判断查车是否返回
          this.carBeans.vehicle.exhaustScale = vhl.exhaustScale; // 排量
          this.carBeans.vehicle.LicenseTypeCode = '07';
          // this.carBeans.vehicle.maxDesignSpeed  = vhl.maxDesignSpeed ? vhl.maxDesignSpeed : '80';
          const jqSyClass = vhl.jqxClassId ? vhl.jqxClassId : vhl.syxClassId;
          // 交管类型
          // carkindcodeshow
          switch(jqSyClass) {
              case 'MA':
                  this.carBeans.vehicle.VehicleCategory = 'M21';
                  this.carBeans.vehicle.carKindCodeShow = '71';
                  break;
              case 'MB':
                  this.carBeans.vehicle.VehicleCategory = 'M21';
                  this.carBeans.vehicle.carKindCodeShow = '72';
                  break;
              case 'MC':
                  this.carBeans.vehicle.VehicleCategory = 'M11';
                  this.carBeans.vehicle.carKindCodeShow = '73';
                  break;
          }
      } else if (vhl.powerTypeCode === '1') {
          // 电动摩托车
          this.isPowerShow = true; // 展示车辆类型
          if (vhl.powerType.indexOf('纯电动') > -1 && vhl.brandName.indexOf('三轮') > -1) {
              this.carKindCodeShow = ['76'];
              this.carBeans.vehicle.carKindCodeShow = '76';
              return;
          }
          if (vhl.power) {
            this.carBeans.vehicle.power = vhl.power
            if (vhl.power <= 4) {
                this.carKindCodeShow = ['74'];
                this.carBeans.vehicle.carKindCodeShow = '74';
                // this.carBeans.vehicle.maxDesignSpeed = "25";
            } else if (vhl.power <= 8) {
                this.carKindCodeShow = ['75'];
                this.carBeans.vehicle.carKindCodeShow = '75';
                // this.carBeans.vehicle.maxDesignSpeed = "60";
            } else if (vhl.power > 8) {
                this.carKindCodeShow = ['76'];
                this.carBeans.vehicle.carKindCodeShow = '76';
                // this.carBeans.vehicle.maxDesignSpeed = "80";
            }
          }
      }
    }
  },
}
